var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfluenced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 432,
    viewBox: "0 0 512 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.211,206.465c0,13.3-8,24.082-17.863,24.082s-15.6-12.383-15.6-25.684,5.73-22.484,15.6-22.484,17.863,10.781,17.863,24.086Zm0,0",
    fill: "#e8916f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.539,206.465c0,13.3,8,24.082,17.863,24.082S512,218.164,512,204.863s-5.73-22.484-15.6-22.484-17.863,10.781-17.863,24.086Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.156,281.125H440.59v58.383H404.156Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.793,228.73V179.492a61.843,61.843,0,0,1,61.844-61.844h7.477a61.842,61.842,0,0,1,61.84,61.844V228.73a65.531,65.531,0,0,1-65.527,65.531h-.105a65.531,65.531,0,0,1-65.527-65.531Zm0,0",
    fill: "#ebad88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.066,117.648h-7.383a62.358,62.358,0,0,0-7.238.438,61.95,61.95,0,0,1,54.648,61.551v48.941a65.663,65.663,0,0,1-54.648,64.77,65.6,65.6,0,0,0,76.508-64.77V179.632a61.937,61.937,0,0,0-61.887-61.984Zm0,0",
    fill: "#e8916f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.629,382.641v8.332a4,4,0,0,1-4,4H341.121a4,4,0,0,1-4-4v-8.332c0-35.863,25.219-64.937,56.328-64.937H451.3c31.109,0,56.328,29.074,56.328,64.938Zm0,0",
    fill: "#47d5e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.3,317.7H420.395c31.109,0,56.328,29.074,56.328,64.938v12.332h26.906a4,4,0,0,0,4-4V382.64c0-35.863-25.219-64.937-56.328-64.937Zm0,0",
    fill: "#22c0d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.066,317.7h54.613l-27.3,77.27Zm0,0",
    fill: "#dcdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.375,394.973l-19.32-81.426a3,3,0,0,0-3.9-2.145l-16.117,5.59a4,4,0,0,0-2.727,3.789v28.363a2.993,2.993,0,0,0,.816,2.055Zm0,0",
    fill: "#20b5c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.375,394.973l19.32-81.426a3,3,0,0,1,3.9-2.145l16.117,5.59a4,4,0,0,1,2.723,3.789v28.363a2.975,2.975,0,0,1-.816,2.055Zm0,0",
    fill: "#20b5c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.512,192.742s5.457,2.207,11.059-8.32c6.406-12.035,23.285-18.758,43.516-18.023,23.348.844,33.9-6.754,39.273-14.973a1,1,0,0,1,1.793.223c6.844,20.383,16.133,15.367,22.238,34.211,3.617,11.16,13.1,6.883,13.1,6.883s26.094-15.152,12.648-39.211c2.309-48.352-35.547-51.215-35.547-51.215s-17.3-22.008-64.734-10.559c-68.441,16.516-56.289,64.684-56.289,64.684s-11.77,22.816,12.945,36.3Zm0,0",
    fill: "#ffd659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.133,153.531c2.313-48.348-35.547-51.211-35.547-51.211s-15.012-19.063-55.355-12.457a51.171,51.171,0,0,1,18.707,7.516,56.931,56.931,0,0,0,13.469,6.727c10.941,3.754,29.457,15.18,27.82,49.426,5.32,9.516,4.445,17.629,1.457,23.973a39.038,39.038,0,0,1,3.707,8.355c3.617,11.16,13.1,6.883,13.1,6.883s26.094-15.152,12.645-39.211Zm0,0",
    fill: "#ffbd54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.41,281.125h36.434v58.383H71.41Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.047,228.73V179.492a61.842,61.842,0,0,1,61.84-61.844h7.477a61.839,61.839,0,0,1,61.84,61.844V228.73a65.529,65.529,0,0,1-65.527,65.531h-.1A65.529,65.529,0,0,1,24.047,228.73Zm0,0",
    fill: "#ebad88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.316,117.648H85.934a62.358,62.358,0,0,0-7.238.438,61.95,61.95,0,0,1,54.648,61.551v48.941A65.663,65.663,0,0,1,78.7,293.347a65.6,65.6,0,0,0,76.508-64.77V179.632a61.934,61.934,0,0,0-61.887-61.984Zm0,0",
    fill: "#e8916f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.879,382.641v8.332a4,4,0,0,1-4,4H8.371a4,4,0,0,1-4-4v-8.332C4.371,346.778,29.59,317.7,60.7,317.7h57.852c31.109,0,56.328,29.074,56.328,64.938Zm0,0",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.551,317.7H87.645c31.113,0,56.328,29.074,56.328,64.938v12.332h26.906a4,4,0,0,0,4-4V382.64c0-35.863-25.219-64.937-56.328-64.937Zm0,0",
    fill: "#e62753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,317.7h54.613l-27.309,77.27Zm0,0",
    fill: "#dcdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.625,394.973,70.3,313.516a3,3,0,0,0-3.875-2.152l-16.137,5.426a4,4,0,0,0-2.723,3.789v28.566a2.982,2.982,0,0,0,.816,2.055Zm0,0",
    fill: "#d6244d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.625,394.973l19.328-81.457a3,3,0,0,1,3.875-2.152l16.137,5.426a4,4,0,0,1,2.727,3.789v28.566a3,3,0,0,1-.816,2.055Zm0,0",
    fill: "#d6244d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.309,149.6s-38.281,17.215-51.5,39.445c-17.371,29.211-17.836,59.328-26.422,88.059a2.006,2.006,0,0,1-3.613.508C14.891,268.414,0,242.46,0,215.484,0,71.226,105.465,88.691,110.176,99.652c21.27-8.906,63.926,9.5,63.926,94,0,40.707-4.594,68.723-17,86.691a2,2,0,0,1-3.609-.691c-2.391-10.738-8.629-40.039-11.605-65.988-6.816-59.492-39.582-64.062-39.582-64.062Zm0,0",
    fill: "#ffd659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.176,99.652c-1.9-4.414-20.141-9.883-41.25-5.414,3.734.906,6.559,3.238,10.016,9.395a44.676,44.676,0,0,0,20.039,18.9c22.973,10.609,37.457,32.75,44.352,71.125,1.629,9.059-.238,17.754-.742,25.691,3.16,24.418,8.691,50.348,10.906,60.309a2,2,0,0,0,3.609.691c12.4-17.969,17-45.984,17-86.691,0-84.5-42.656-102.91-63.926-94Zm0,0",
    fill: "#ffbd54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.594,166.316c0,18.746-11.309,33.941-25.254,33.941s-22.051-17.449-22.051-36.2,8.1-31.687,22.051-31.687,25.254,15.2,25.254,33.941Zm0,0",
    fill: "#e8916f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.406,166.316c0,18.746,11.309,33.941,25.254,33.941s22.051-17.449,22.051-36.2-8.1-31.687-22.051-31.687-25.254,15.2-25.254,33.941Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.246,271.543h51.508v82.285H230.246Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.285,197.414v-68.84a87.428,87.428,0,0,1,87.43-87.43h10.57a87.429,87.429,0,0,1,87.434,87.43v68.84a92.647,92.647,0,0,1-92.645,92.645h-.145a92.645,92.645,0,0,1-92.645-92.645Zm0,0",
    fill: "#ebad88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.219,41.145H250.781a88.5,88.5,0,0,0-10.234.613,87.414,87.414,0,0,1,77.266,86.75v68.98a92.637,92.637,0,0,1-77.266,91.285A93.711,93.711,0,0,0,256,290.059a92.641,92.641,0,0,0,92.715-92.57v-68.98a87.428,87.428,0,0,0-87.5-87.363Zm0,0",
    fill: "#e8916f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.531,414.617V426a6,6,0,0,1-6,6H141.468a6,6,0,0,1-6-6V414.617c0-50.543,35.652-91.516,79.637-91.516h81.789c43.984,0,79.637,40.973,79.637,91.516Zm0,0",
    fill: "#685c79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.895,323.1H265.989c43.984,0,79.641,40.973,79.641,91.516V432h24.9a6,6,0,0,0,6-6V414.618c0-50.543-35.652-91.516-79.637-91.516Zm0,0",
    fill: "#594f69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,323.1h77.211L256,432Zm0,0",
    fill: "#ffd659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.57,211.02a7.5,7.5,0,0,0-9.773,4.121c-.07.18-7.559,17.832-33.871,17.832-26.18,0-35.5-17.473-35.953-18.348a7.5,7.5,0,0,0-13.453,6.637c.535,1.09,13.473,26.711,49.406,26.711,36.293,0,47.316-26.07,47.766-27.18a7.5,7.5,0,0,0-4.121-9.773Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.9,151.727a76.642,76.642,0,0,0-40.328,3.207,7.5,7.5,0,1,0,5.027,14.133,62.586,62.586,0,0,1,31.785-2.758,7.5,7.5,0,0,0,3.516-14.582Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,169.066a7.5,7.5,0,0,0,5.027-14.133,76.659,76.659,0,0,0-40.332-3.207,7.5,7.5,0,0,0,3.488,14.59,62.558,62.558,0,0,1,31.816,2.75Zm0,0",
    fill: "#d98868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,432,228.359,315.879a3,3,0,0,0-3.871-2.148l-25.23,8.457a4,4,0,0,0-2.73,3.793v41.578a3,3,0,0,0,1.242,2.43l12.59,9.113a3.007,3.007,0,0,1,1.238,2.43V398.25a2.994,2.994,0,0,0,1.238,2.426Zm0,0",
    fill: "#50475e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,432l27.641-116.121a3,3,0,0,1,3.871-2.148l25.23,8.457a4,4,0,0,1,2.73,3.793v41.578a3,3,0,0,1-1.242,2.43l-12.59,9.113a3.007,3.007,0,0,0-1.238,2.43V398.25a2.994,2.994,0,0,1-1.238,2.426Zm0,0",
    fill: "#50475e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.887,146.98s7.711,3.105,15.633-11.727c9.055-16.965,32.922-26.438,61.52-25.406,33.7,1.215,48.543-9.969,55.992-21.832a1,1,0,0,1,1.793.223c9.7,29.688,23,22.227,31.719,49.039,5.109,15.73,18.516,9.7,18.516,9.7s36.891-21.355,17.879-55.266c3.266-68.145-50.258-72.18-50.258-72.18S291.219-11.481,224.16,4.652C127.4,27.933,144.578,95.82,144.578,95.82s-16.641,32.156,18.309,51.16Zm0,0",
    fill: "#8c4a37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.938,91.715c3.266-68.145-50.258-72.18-50.258-72.18S296.207-5.152,244.387.98c28.875,3.961,40.387,18.555,40.387,18.555s53.523,4.035,50.258,72.18c11.207,19.992,2.984,35.617-5.652,45.078.055.164.109.32.16.484,5.113,15.73,18.52,9.7,18.52,9.7s36.891-21.355,17.879-55.266Zm0,0",
    fill: "#804231"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluenced);
export default __webpack_public_path__ + "static/media/influenced.78fc59f8395f31987bb91b21bad85f33.svg";
export { ForwardRef as ReactComponent };